import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-confirm-quotation-dialog',
  templateUrl: './confirm-quotation-dialog.component.html',
  styleUrls: ['./confirm-quotation-dialog.component.scss']
})
export class ConfirmQuotationDialogComponent implements OnInit {

  @Output() returnValue = new EventEmitter<null>();

  isShow: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

  /**
   * open dialog
   */
  openDialog(){
    this.isShow = true;
  }

  /**
   * confirm quoting agenda
   */
  confirm(){
    this.returnValue.emit();
    this.isShow = false;
  }

  /**
   * close dialog without quoting
   */
  closeDialog(){
    this.isShow = false;
  }

}
